import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { saveToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export const ADMIN_TOKEN_BACKUP = "mo_admin_token";

export const AdminImpersonateButton = ({ restaurant }) => {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const [busy, setBusy] = useState(false);

  const enter = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/impersonate/${restaurant.owner_id}`);
      const adminToken = localStorage.getItem("mo_token");
      if (adminToken) localStorage.setItem(ADMIN_TOKEN_BACKUP, adminToken);
      saveToken(data.token);
      applyAuth(data);
      toast.success(`Stai vedendo la dashboard di ${restaurant.name}`);
      navigate("/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Operazione non riuscita");
      setBusy(false);
    }
  };

  return (
    <Button variant="ghost" size="sm" onClick={enter} disabled={busy} title="Entra come ristoratore"
      className="text-[#4a8a56] hover:bg-[#5aa469]/10" data-testid={`admin-impersonate-${restaurant.id}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogIn className="h-4 w-4" />}
    </Button>
  );
};
